import { __assign } from "tslib";
// DS: i6.13
import React from 'react';
import IconWrap from '../IconWrap';
var TheaterView = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M20 16H4V9h16v7zm1-9H3a1 1 0 00-1 1v9a1 1 0 001 1h18a1 1 0 001-1V8a1 1 0 00-1-1z" }))));
};
TheaterView.displayName = 'TheaterView';
export default TheaterView;
//# sourceMappingURL=TheaterView.js.map